module.exports = __webpack_public_path__ + "img/racecourse-flamingoPark-sand-1000.c12bb20e.svg";